<template>
  <div id="thanks">
    <Background />
    <h2 class="m-8">Thank You!</h2>
    <div class="m-2">
      <p>Thank you for your partnership in the gospel!</p>
      <p>You should receive an email confirming your donation.</p>
    </div>
    <div class="m-8">
      <router-link class="btn-pill orange-pill" to="/">Return</router-link>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>

import Background from './Background.vue'

export default {
  data () {
    return {
    }
  },
  components: {
    Background
  },
  props: {
    email: String
  }
}

</script>